module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Plus-190fd74e1876a38dd15deafa82fffe51.svg";